import { Divider, Flex, Typography } from 'antd'
import ProfilePic from 'src/assets/images/profile-pic.png'
import './index.scss'
import { cloneDeep } from 'lodash'
import { ChangePasswordIcon, LogoutIcon } from 'src/assets/icons'
import { useTranslation } from 'react-i18next'
import { logOutApp } from 'src/app/store'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ResetPasswordType, SYSTEM_ROLES } from 'src/app/shared/models/common.model'
import { getAccessToken, getUserProfile } from 'src/app/store/auth'
import { useSelector } from 'react-redux'
import { appChannel } from 'src/app/App'
import { APP_CHANNEL_ACTIONS } from 'src/app/shared/constants/app.constants'
import { lcStorageUserRole } from 'src/app/shared/constants/localStorage.constants'

const AccountMenu = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const accessToken = useSelector(getAccessToken)
  const userProfile = useSelector(getUserProfile)

  const handleLogout = () => {
    appChannel.postMessage({ type: APP_CHANNEL_ACTIONS.LOGOUT })
    if (accessToken) {
      const cloneUserRole = cloneDeep(userProfile?.role ?? '')
      sessionStorage.removeItem(lcStorageUserRole)
      navigate('/log-out', {
        state: {
          userRole: cloneUserRole,
        },
      })
      dispatch(logOutApp())
    }
  }

  const onClickChangePassword = () => {
    navigate('/reset-password', {
      state: {
        resetPasswordType: ResetPasswordType.MANUAL_RESET,
      },
    })
  }

  return (
    <Flex gap={10} vertical className='account-menu'>
      <Flex vertical align='center' style={{ padding: '12px 0' }}>
        <img className='profile-picture' src={ProfilePic} alt='' />
        <Typography.Text style={{ fontSize: '16px', paddingTop: '8px' }}>{userProfile?.name}</Typography.Text>
      </Flex>

      {!userProfile?.role?.includes(SYSTEM_ROLES.CLIENT_USER) ? (
        <>
          <Divider style={{ margin: '0' }} />
          <Flex onClick={onClickChangePassword} style={{ padding: '8px 16px', cursor: 'pointer' }} gap={10}>
            <ChangePasswordIcon />
            <Typography.Text>{t('LoginPage:change_password_btn')}</Typography.Text>
          </Flex>
        </>
      ) : null}

      <Divider style={{ margin: '0' }} />
      <Flex onClick={handleLogout} style={{ padding: '8px 16px', cursor: 'pointer' }} gap={10}>
        <LogoutIcon />
        <Typography.Text>{t('LoginPage:logout_btn')}</Typography.Text>
      </Flex>
    </Flex>
  )
}

export default AccountMenu
